<template>
  <Info>
    {{ errorText }}
  </Info>
</template>

<script>
export default {
  name: "UrlError",
  components: {
    Info: () => import("@/components/auth/Info"),
  },
  props: {
    message: { type: String, required: true },
  },
  data: () => {
    return {
      errorText: null,
    };
  },
  mounted() {
    this.errorText = this.message;
  },
};
</script>

<style scoped></style>
